import React, { Component } from 'react';

class Checkbox extends Component {

    constructor(props){
        super(props);
        this.state={
            checked: this.props.checked
        }
        this.onChange = this.onChange.bind(this);
    }

    onChange(event){
        if(event.target.checked){
            this.setState({
                checked: true
            });
        }else{
            this.setState({
                checked: false
            });
        }
        if(typeof this.props.onChange !== 'undefined'){
            this.props.onChange(event);
        }        
    }

    render(){

        return(
            <div className={this.state.checked ? 'vb-checked' : ''}>
                <input type="checkbox" onChange={this.onChange} defaultValue={this.state.value} defaultChecked={this.state.checked} item={this.props.item} id={this.props.id}/>
            </div>
        )
    }
}

export default Checkbox;